import { EN_LOCALE_TEXT } from '@whitelabel/rentalcover-shared/helpers/constants';
import languagesRC from '@whitelabel/rentalcover-shared/helpers/constants/languagesRC.json';

function getSelectedLocale(browserLanguage: string, languageArray: string[]) {
  const translatedLanguage =
    languageArray.find((lang) => lang === browserLanguage) ||
    languageArray.find((lang) => browserLanguage.startsWith(lang));
  return translatedLanguage || EN_LOCALE_TEXT;
}

function getBrowserLanguage() {
  return (navigator.languages && navigator.languages[0]) || navigator.language || (navigator as any).userLanguage;
}

/**
 * Detects the user's language and redirects them to the correct locale if necessary
 * @returns locale
 */
export function detectLanguage() {
  const { pathname: urlPathname } = window.location;
  const pathLanguage = urlPathname.split('/')[1];

  const availableLocales = Object.keys(languagesRC);
  if (!pathLanguage || !availableLocales.includes(pathLanguage)) {
    let translatedLanguage = EN_LOCALE_TEXT;
    let restPath = urlPathname;
    // For email links from XCMS, the locale in url is XC locale standard, convert to RC locale
    const isXCLocale = Object.values(languagesRC).find((lang) => lang.xcode === pathLanguage);
    if (isXCLocale) {
      translatedLanguage = isXCLocale.urlPrefix;
      restPath = urlPathname.replace(`/${pathLanguage}`, '');
    } else {
      translatedLanguage = getSelectedLocale(getBrowserLanguage(), availableLocales);
    }

    let newURL = `/${translatedLanguage}${restPath}`;
    newURL = newURL.replace(/(\/)+$/, '');
    window.location.replace(newURL);
    return null;
  }

  return pathLanguage;
}

export function mapRCLocaleToXC(rcLocale: string): string | undefined {
  const localeObject = Object.values(languagesRC).find((lang) => lang.urlPrefix === rcLocale);

  return localeObject?.xcode;
}
